export const SupportRoutes = [
  {
    path: 'support/features',
    lazy: () => import('./features.page'),
  },
] as const
